import React from 'react';
import DrawBase from '../components/base/draw-base';

const TourneysComponentsFormRulesPartDraw = () => {
  return <DrawBase sportType="general" />;
};

export default TourneysComponentsFormRulesPartDraw;
